import { TemplateCheckResponse, TemplateType } from "@/types/template.types";
import { create } from "zustand";

type TemplateStore = {
  template: TemplateType | null;
  storeTemplate: (template: TemplateType) => void;
  clearStoredTemplate: () => void;
  report: TemplateCheckResponse | null;
  setReport: (report: TemplateCheckResponse) => void;
  clearReport: () => void;
};

export const useTemplateStore = create<TemplateStore>((set) => ({
  template: null,
  storeTemplate: (template: TemplateType) => set({ template }),
  clearStoredTemplate: () => set({ template: null }),
  report: null,
  setReport: (report: TemplateCheckResponse) => set({ report }),
  clearReport: () => set({ report: null }),
}));
